import { dashCaseToCamelCase } from "prettier";
import { use } from "react";
import HELPERS from "utils/helper";

const DASHBOARD_API = {
  getTasks: () => {
    return HELPERS.secureRequest({
      url: `tasks/`,
      method: "GET",
    });
  },
  addTask: (task) => {
    return HELPERS.secureRequest({
      url: `tasks/`,
      method: "POST",
      data: task,
    });
  },
  updateTask: (taskId, data) => {
    return HELPERS.secureRequest({
      url: `tasks/${taskId}/`,
      method: "PATCH",
      data: data,
    });
  },
  deleteTask: (taskId) => {
    return HELPERS.secureRequest({
      url: `tasks/${taskId}/`,
      method: "DELETE",
    });
  },
  get: () => {
    return HELPERS.secureRequest({
      url: `users/dashboard/`,
      method: "GET",
    });
  },
  fetchTasksAsync: () => {
    return HELPERS.secureRequest({
      url: `tasks/`,
      method: "GET",
    });
  },
  setShortTermGoals: (items, user_id) => {
    return HELPERS.secureRequest({
      url: `users/short-term-goals/`,
      method: "PATCH",
      data: { items, user_id },
      user_id: user_id,
    });
  },
  setProfessionalSummary: (items) => {
    return HELPERS.secureRequest({
      url: `users/professional-summary/`,
      method: "PATCH",
      data: { items },
    });
  },
  setGoal: (stepId, complete_by, task_title) => {
    return HELPERS.secureRequest({
      url: `stepreflection/${stepId}/setgoal/`,
      method: "POST",
      data: HELPERS.converToFormData({ complete_by, task_title }),
    });
  },
  setStepNotified: (stepId) => {
    return HELPERS.secureRequest({
      url: `stepreflection/${stepId}/isnotified/`,
      method: "POST",
    });
  },
  updateStepReflection: (stepId, data) => {
    return HELPERS.secureRequest({
      url: `stepreflection/${stepId}/`,
      method: "PATCH",
      data: data,
    });
  },
  updateProfile: (data, Stepname) => {
    return HELPERS.secureRequest({
      url: `users/profile/`,
      method: "PATCH",
      data: data,
      Stepname,
    });
  },
  getProfessionalSummary: (user_id) => {
    return HELPERS.secureRequest({
      url: `customize_dash/professional-summary/`,
      method: "GET",
      data: user_id,
    });
  },

  getTimelineStep: (user_id) => {
    return HELPERS.secureRequest({
      url: `customize_dash/timeline-step/${user_id}`,
      method: "GET",
      data: user_id,
    });
  },

  getTimeline: (user_id) => {
    return HELPERS.secureRequest({
      url:`users/timeline/${user_id}`,
      method: "GET",
      data: user_id,
    });
  },

  getCoachSummary: (user_id) => {
    return HELPERS.secureRequest({
      url: `users/fetch_coach_summary/${user_id}`,
      method: "GET",
    });
  },
  updateCoachSummary: (data, user_id) =>{
    return HELPERS.secureRequest({
      url: `users/fetch_coach_summary/${user_id}`,
      method: "PATCH",
      data: { data, user_id },
      user_id: user_id,
    });
  },
  getShortTermGoals: (user_id) => {
    return HELPERS.secureRequest({
      url: `users/fetch_short-term-goals/${user_id}`,
      method: "GET",
      
    });
  },
  deleteShortTermGoals: (goalID, stepId, user_id) => {

    return HELPERS.secureRequest({

      url: `users/del_short-term-goals/${goalID}`,

      method: "DELETE",

      data: { goalID, stepId, user_id },

    });
  },
  updateUpcomingMeetingsFilter: (items, user_id) =>{

    return HELPERS.secureRequest({

      url: `customize_dash/upcoming-meeting-filters/`,

      method: "PATCH",

      data: { items, user_id },

      user_id: user_id,

    });

  },
  getUpcomingMeetings: (user_id, all) =>{
    return HELPERS.secureRequest({
      url: `customize_dash/upcoming-meeting/${user_id}`,
      method: "GET",
      data: {user_id, all},
    });
  },
  geAlltUpcomingMeetings: (user_id, all) =>{
    return HELPERS.secureRequest({
      url: `customize_dash/upcoming-meeting/${user_id}`,
      method: "GET",
      params: {all},
    });
  },
  updateUpcomingMeetings: (items, user_id) =>{
    return HELPERS.secureRequest({
      url: `customize_dash/upcoming-meeting/`,
      method: "PATCH",
      data: { items, user_id },
      user_id: user_id,
    });
  },
  // Fetch the saved dashboard layout
  getDashboardItems: (userID) => {
    return HELPERS.secureRequest({
      url: `customize_dash/${userID}/`,
      method: "GET",
    });
  },
  // Update the dashboard layout when items are moved
  updateDashboardItems: (items) => {
    return HELPERS.secureRequest({
      url: `customize_dash`,
      method: "PATCH",
      data: { items },
    });
  },

  // Delete a component from the dashboard
  deleteDashboardItem: (items) => {
    return HELPERS.secureRequest({
      url: `customize_dash`,
      method: "DELETE",
      data: { items },
    });
  },

  //Career Roadmap post details
  updateTimeline: (data, user_id) => {
    return HELPERS.secureRequest({
      url: `customize_dash/add_careerroadmap`,
      method: "POST",
      data: { data, user_id },
    });
  },
  
  //Career Roadmap step post details
  updateTimelineStep: (data, user_id) => {
    return HELPERS.secureRequest({
      url: `customize_dash/add_careersteps`,
      method: "POST",
      data: { data, user_id },
    });
  },
  
};

export default DASHBOARD_API;
